
export function getPlainTextSummary(html: string): string {
  if (!html) return "";

  // Strip all HTML tags using regex
  const textOnly = html.replace(/<[^>]+>/g, "").trim();

  // Optionally decode HTML entities (like &nbsp;, &amp;)
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = textOnly;
  return tempDiv.textContent || tempDiv.innerText || "";
}